module.exports = __webpack_public_path__ + "static/WEDDING E&M-587-8c047cbe38af85add8de1034b1a2b919.jpg";